<template>
  <div class="cart-sidebar shadow-lg rounded-4 overflow-hidden border-0 card">

    <!-- Header -->
    <div class="cart-header p-3 bg-dark text-white d-flex justify-content-between align-items-center">
      <h5 class="m-0">SAVATCHA</h5>
      <div class="d-flex gap-2">
        <div class="currency-switch" aria-label="Narx valyutasi">
          <button type="button" :class="{ active: !isDollarMode }" @click="setCurrencyMode('som')">So'm</button>
          <button type="button" :class="{ active: isDollarMode }" @click="setCurrencyMode('dollar')">$</button>
        </div>
        <button v-if="hasServices" @click="$emit('clear-services')" class="btn btn-sm btn-outline-warning border-0" title="Xizmatlarni tozalash">Xizmatlar ×</button>
        <button @click="$emit('clear-all')" class="btn btn-sm btn-outline-light border-0">Hammasi ×</button>
      </div>
    </div>

    <!-- Savatcha ro'yxati -->
    <div class="cart-items p-2 overflow-auto">
      <div v-if="cart.length === 0" class="text-center py-4">
        <p class="text-muted small mb-0">Savatcha bo'sh</p>
      </div>

      <div v-for="(item, index) in cart" :key="index" class="cart-row mb-2"
           :class="[item.type === 'service' ? 'service-row' : '', item.from_service ? 'service-product-row' : '']">

        <!-- Xizmatga tegishli mahsulot (kichik ko'rinishda) -->
        <template v-if="item.from_service">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <span class="small text-muted d-block" style="word-break:break-word; overflow-wrap:anywhere;">↳ {{ item.name }}</span>
              <span class="badge bg-info" style="font-size:0.55rem">Material</span>
            </div>
            <span class="small text-muted">{{ item.qty }} x {{ formatPrice(item.price, item.dollar_price) }} = {{ formatPrice(item.price * item.qty, Number(item.dollar_price || 0) * item.qty) }}</span>
          </div>
        </template>

        <!-- Oddiy mahsulot yoki xizmat -->
        <template v-else>
          <div class="d-flex justify-content-between align-items-start mb-1">
            <div>
              <span class="small fw-bold d-block" style="word-break:break-word; overflow-wrap:anywhere;">{{ item.name }}</span>
              <span :class="['badge', item.type === 'service' ? 'bg-purple' : 'bg-secondary']" style="font-size:0.6rem">
                {{ item.type === 'service' ? 'Xizmat' : 'Mahsulot' }}
              </span>
            </div>
            <button @click="$emit('remove-item', index)" class="btn-close-sm">&times;</button>
          </div>

          <!-- Xizmat uchun narx ko'rinishi -->
          <div v-if="item.type === 'service'" class="mb-1">
            <small class="text-muted d-block">
              {{ saleType === 'optom' ? 'Optom' : 'Chakana' }}:
              {{ formatPrice(serviceItemPrice(item)) }}/ta
            </small>
            <small v-if="serviceMaterialsSumma(item) > 0" class="text-info d-block">
              Zapchast: {{ formatPrice(serviceMaterialsSumma(item)) }}
            </small>
          </div>
          <!-- Mahsulot uchun dona narxi -->
          <div v-else class="mb-1">
            <small class="text-muted d-block">
              {{ saleType === 'optom' ? 'Optom' : 'Chakana' }}:
              {{ formatPrice(item.price, item.dollar_price) }}/dona
            </small>
          </div>

          <div class="d-flex justify-content-between align-items-center">
            <div class="quantity-control">
              <button @click="$emit('decrease-qty', item)" class="qty-btn">-</button>
              <span class="qty-val">{{ item.qty }}</span>
              <button @click="$emit('increase-qty', item)" class="qty-btn">+</button>
            </div>
            <span class="fw-bold text-primary small">
              {{ item.type === 'service'
                 ? formatPrice(serviceItemPrice(item) * item.qty)
                 : formatPrice(item.price * item.qty, Number(item.dollar_price || 0) * item.qty) }}
            </span>
          </div>
        </template>
      </div>
    </div>

    <!-- Summary va To'lov -->
    <div class="cart-summary p-3 bg-white border-top">

      <!-- Scroll qismi (tugma tashqarida, doim ko'rinadi) -->
      <div class="summary-scroll">

      <!-- Summa detallari -->
      <div class="summary-details">
        <div v-if="hasServices" class="d-flex justify-content-between mb-1 align-items-center">
          <span class="text-muted small">Xizmatlar</span>
          <span class="fw-bold small text-purple">{{ formatPrice(serviceSumma) }}</span>
        </div>
        <div v-if="hasProducts" class="d-flex justify-content-between mb-1 align-items-center">
          <span class="text-muted small">Mahsulotlar</span>
          <span class="fw-bold small">{{ formatPrice(productSumma, productDollarSumma) }}</span>
        </div>
        <div class="d-flex justify-content-between mb-1 align-items-center">
          <span class="text-muted small">Chegirma</span>
          <input type="number" :value="form.skidka_summa" @input="updateForm('skidka_summa', $event)" class="summary-input-field text-danger">
        </div>
        <div v-if="form.master_user_id" class="d-flex justify-content-between mb-1 align-items-center">
          <span class="text-muted small">Usta ({{ masterPercent }}%)</span>
          <span class="fw-bold small text-info">{{ formatSumma(masterSumma) }}</span>
        </div>
        <div class="d-flex justify-content-between mt-2 pt-2 border-top">
          <h5 class="fw-bolder m-0">JAMI:</h5>
          <h5 class="fw-bolder m-0 text-dark">{{ formatPrice(totalSum, totalDollarSumma) }}</h5>
        </div>
      </div>

      <!-- ================= TO'LOV TURLARI ================= -->
      <div class="payment-section mt-3">
        <div class="pay-head">
          <span class="pay-head-title">TO'LOV TURLARI</span>
          <button type="button" class="btn-all-cash" @click="payAllCash">⚡ Hammasi Naqdga</button>
        </div>

        <!-- To'lov turi kartalari -->
        <div
          v-for="def in activeDefs"
          :key="def.id"
          class="pay-card"
          :class="{ 'pay-card-filled': getPayValue(def) > 0 }"
        >
          <div class="pay-card-icon" :style="{ background: def.color }">{{ def.icon }}</div>
          <div class="pay-card-meta">
            <div class="pay-card-name">{{ def.label }}</div>
            <div class="pay-card-sub">{{ def.sub }}</div>
          </div>
          <div class="pay-card-input">
            <summa-input
              :value="getPayValue(def)"
              @input="onCardInput(def, $event)"
            />
            <small v-if="def.dollar && getPayValue(def) > 0" class="pay-card-hint">
              ≈ {{ formatSumma(getPayValue(def) * rate) }} so'm
            </small>
          </div>
          <button type="button" class="btn-qoldiq" @click="fillRemainder(def)">Qoldiq</button>
        </div>

        <!-- Yig'indilar -->
        <div class="pay-totals mt-3">
          <div class="d-flex justify-content-between align-items-center">
            <span class="text-muted small fw-bold">Jami to'lanmoqda:</span>
            <span class="fw-bold">{{ formatPrice(paidSomTotal) }}</span>
          </div>
          <div v-if="returnSom > 0" class="d-flex justify-content-between align-items-center mt-1 return-row">
            <span class="fw-bold small">Qaytim:</span>
            <span class="fw-bolder">{{ formatSumma(returnSom) }} so'm</span>
          </div>
          <div v-if="qarzgaQoladi > 0" class="d-flex justify-content-between align-items-center mt-1">
            <span class="fw-bold text-danger small">Qarzga qoladi:</span>
            <span class="fw-bolder text-danger">{{ formatPrice(qarzgaQoladi) }}</span>
          </div>
        </div>

        <!-- ============== QARZ TURI (qoldiq qarz bo'lsa) ============== -->
        <div v-if="qarzgaQoladi > 0" class="qarz-turi mt-3">
          <div class="qarz-head">
            <span class="qarz-title">💱 QARZ TURI</span>
            <span class="qarz-kurs">Kursi: {{ formatSumma(rate) }}</span>
          </div>

          <!-- MIJOZ TANLASH OGOHLANTIRISHI (qarz bor, lekin mijoz tanlanmagan) -->
          <div v-if="!form.kontragent_id" class="qarz-warning">
            <b-icon icon="exclamation-triangle-fill" class="me-1"></b-icon>
            <span><b>Mijoz tanlash majburiy!</b> Qarzga berish uchun yuqoridan mijoz tanlang.</span>
          </div>

          <div v-if="isDollarMode" class="qarz-row">
            <label>Qarz dollarda:</label>
            <span class="fw-bolder text-danger">$ {{ (qarzgaQoladi / rate).toFixed(2) }}</span>
          </div>

          <div v-if="!isDollarMode" class="qarz-quick">
            <button
              v-for="b in dollarQuickButtons"
              :key="b.label"
              type="button"
              class="qarz-q-btn"
              :class="{ active: qarzDollar === b.value, 'qarz-q-max': b.max }"
              @click="setQarzDollar(b.value)"
            >{{ b.label }}</button>
          </div>

          <div v-if="!isDollarMode" class="qarz-row">
            <label>Qarz dollarda:</label>
            <div class="qarz-dollar-input">
              <input type="number" min="0" :value="qarzDollar" @input="onQarzDollarInput($event)" @focus="$event.target.select()">
              <span class="qarz-cur">$</span>
            </div>
          </div>

          <div v-if="!isDollarMode" class="qarz-row qarz-som-row">
            <label>So'm qarz:</label>
            <span class="fw-bolder text-danger">{{ formatSumma(somQarz) }} so'm</span>
          </div>

          <div class="qarz-row mt-2">
            <label style="white-space:nowrap;">
              Nasiya muddati: <small class="text-muted" style="font-weight:500">(ixtiyoriy)</small>
            </label>
            <input type="date" :value="form.nasiya_date" @input="updateForm('nasiya_date', $event)" class="qarz-date">
          </div>
        </div>

        <div v-else-if="totalSum > 0" class="status-badge paid-badge mt-2">
          <span>✅ To'liq to'landi</span>
        </div>

        <!-- Hammasi qarzga -->
        <button type="button" class="btn-all-debt mt-2" @click="payAllDebt">
          ⏳ Hammasi qarzga (to'lov yo'q)
        </button>
      </div>

      <!-- Mijoz qarzi bo'lsa -->
      <div v-if="clientDebt > 0" class="debt-section mt-3 p-3 rounded-3 border border-danger border-opacity-25">
        <div v-if="Math.abs(clientDebtSom) > 0.01" class="d-flex justify-content-between align-items-center mb-1">
          <span class="fw-bold text-danger small">💳 Mijoz qarzi:</span>
          <span class="fw-bolder text-danger">{{ formatSumma(clientDebtSom) }} so'm</span>
        </div>
        <div v-if="Math.abs(clientDebtDollar) > 0.001" class="d-flex justify-content-between align-items-center mb-2">
          <span class="fw-bold text-danger small">💳 Mijoz qarzi ($):</span>
          <span class="fw-bolder text-danger">$ {{ Number(clientDebtDollar).toFixed(2) }}</span>
        </div>
        <payment-splitter
          v-model="debtPayTable"
          :paytypes="paytypes"
          :dollar-rate="form.dollar_rate || dollarRate"
          :dollar-pay-type-ids="[3]"
          :expected-total="clientDebt"
          :autofill-first="false"
        />
        <button
          @click="payDebt"
          :disabled="debtPayTotal <= 0 || debtLoading"
          class="btn btn-sm btn-danger w-100 fw-bold mt-2"
        >
          <span v-if="debtLoading" class="spinner-border spinner-border-sm me-1"></span>
          Qarzni To'lash ({{ formatSumma(debtPayTotal) }} so'm)
        </button>
      </div>

      </div><!-- /summary-scroll -->

      <!-- Sotishni yakunlash tugmasi (pinned — doim ko'rinadi) -->
      <button
        @click="$emit('submit')"
        :disabled="loading || debtBlockSubmit"
        :title="debtBlockSubmit ? 'Qarzga berish uchun mijoz tanlash majburiy' : ''"
        class="btn btn-checkout w-100 py-3 rounded-3 shadow mt-3"
      >
        <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
        <template v-if="debtBlockSubmit">⚠ MIJOZ TANLANG (QARZ)</template>
        <template v-else>SOTISHNI YAKUNLASH</template>
      </button>

      <!-- Kechiktirish (hold) tugmasi — savatchani saqlab, yangi savdo boshlash -->
      <button
        @click="$emit('park')"
        :disabled="loading || parking || cart.length === 0"
        title="Savdoni vaqtincha saqlab, yangi savdo boshlash"
        class="btn btn-park w-100 py-2 rounded-3 mt-2"
      >
        <span v-if="parking" class="spinner-border spinner-border-sm me-2"></span>
        ⏸ KECHIKTIRISH
      </button>

    </div>
  </div>
</template>

<script>
import PaymentSplitter from '../../../components/PaymentSplitter.vue';

// Tizimning standart to'lov turlari (id 1-4). Custom turlar — pay_table_amounts ichida saqlanadi.
const SYSTEM_PAY_DEFS = {
  1: { id: 1, field: 'cash_summa',    label: 'Накд',         sub: "SO'M", icon: '💵', color: '#dcfce7', dollar: false },
  2: { id: 2, field: 'plastic_summa', label: 'Пластик',      sub: "SO'M", icon: '💳', color: '#dbeafe', dollar: false },
  3: { id: 3, field: 'dollar_summa',  label: 'Dollar',       sub: 'USD',  icon: '💲', color: '#fef9c3', dollar: true  },
  4: { id: 4, field: 'shot_summa',    label: 'Перечесления', sub: "SO'M", icon: '🏦', color: '#fce7f3', dollar: false },
};

// Custom paytype uchun ranglar palitra
const CUSTOM_COLORS = ['#f3e8ff', '#fce7f3', '#cffafe', '#ecfccb', '#fed7aa', '#e0e7ff', '#ffe4e6'];
const CUSTOM_ICONS = ['💼', '🏧', '💰', '🪙', '📲', '🌐', '🎫'];

const QARZ_QUICK_VALUES = [0, 50, 100, 150, 200, 500];

export default {
  name: 'SaleCartSidebar',
  components: { PaymentSplitter },
  props: {
    cart:          { type: Array,   default: () => [] },
    form:          { type: Object,  required: true },
    saleType:      { type: String,  default: 'chakana' },
    totalSum:      { type: Number,  default: 0 },
    productSumma:  { type: Number,  default: 0 },
    serviceSumma:  { type: Number,  default: 0 },
    paidTotal:     { type: Number,  default: 0 },
    masterPercent: { type: Number,  default: 0 },
    masterSumma:   { type: Number,  default: 0 },
    loading:       { type: Boolean, default: false },
    parking:       { type: Boolean, default: false },
    clientDebt:    { type: Number,  default: 0 },
    clientDebtSom:    { type: Number, default: 0 },
    clientDebtDollar: { type: Number, default: 0 },
    paytypes:      { type: Array,   default: () => [] },
    dollarRate:    { type: [Number, String], default: 1 },
  },
  emits: [
    'update:form',
    'remove-item', 'increase-qty', 'decrease-qty',
    'clear-all', 'clear-services',
    'pay-cash', 'pay-plastic',
    'pay-debt', 'submit', 'park',
  ],
  data() {
    return {
      debtLoading: false,
      debtPayTable: [],
    };
  },
  computed: {
    hasServices() { return this.cart.some(i => i.type === 'service'); },
    hasProducts()  { return this.cart.some(i => i.type === 'product'); },

    rate() {
      return parseFloat(this.form.dollar_rate || this.dollarRate) || 1;
    },
    isDollarMode() {
      return this.form.currency_mode === 'dollar';
    },

    // Backend dan kelgan barcha pay_type larni kartochka qilib chiqaradi.
    // Tizim turlari (1-4) — SYSTEM_PAY_DEFS dan, custom turlar — avto-generated.
    // pay_type ro'yxati bo'sh bo'lsa — 4 ta standart turni ko'rsatadi (fallback).
    activeDefs() {
      const list = this.paytypes || [];
      if (!list.length) return Object.values(SYSTEM_PAY_DEFS);

      return list.map((pt, idx) => {
        const id = parseInt(pt.id);
        if (SYSTEM_PAY_DEFS[id]) {
          // Tizim turi — backenddan kelgan nom bo'lsa, label sifatida ishlatamiz
          return { ...SYSTEM_PAY_DEFS[id], label: pt.name || SYSTEM_PAY_DEFS[id].label };
        }
        // Custom tur — pay_table_amounts ichida saqlanadi (field: pt_<id>)
        const colorIdx = (idx + 4) % CUSTOM_COLORS.length;
        return {
          id,
          custom: true,
          field: `pt_${id}`,
          label: pt.name || `Tur #${id}`,
          sub: "SO'M",
          icon: CUSTOM_ICONS[colorIdx % CUSTOM_ICONS.length],
          color: CUSTOM_COLORS[colorIdx],
          dollar: false,
        };
      });
    },

    // To'lov maydonining qiymatini olish (system: form[field], custom: form.pay_table_amounts[id])
    // Joriy to'lov so'm ekvivalenti (dollar entrylar kursga ko'paytirilgan)
    paidSomTotal() {
      return this.activeDefs.reduce((acc, d) => {
        const v = this.getPayValue(d);
        if (v <= 0) return acc;
        return acc + (d.dollar ? v * this.rate : v);
      }, 0);
    },
    productDollarSumma() {
      return this.cart
        .filter(i => i.type === 'product')
        .reduce((sum, i) => {
          const dollar = Number(i.dollar_price || 0) || Number(i.price || 0) / this.rate;
          return sum + dollar * Number(i.qty || 0);
        }, 0);
    },
    totalDollarSumma() {
      return this.productDollarSumma + Number(this.serviceSumma || 0) / this.rate
        - Number(this.form.skidka_summa || 0) / this.rate;
    },

    qarzgaQoladi() {
      if (this.totalSum <= 0) return 0;
      const diff = this.totalSum - this.paidSomTotal;
      return diff > 0 ? diff : 0;
    },
    returnSom() {
      if ((Number(this.form.dollar_summa) || 0) <= 0) return 0;
      return Math.max(0, this.paidSomTotal - this.totalSum);
    },

    // Qarzga berish uchun mijoz tanlanmagan bo'lsa submit'ni bloklash
    debtBlockSubmit() {
      return this.qarzgaQoladi > 0 && !this.form.kontragent_id;
    },

    // Qoldiqning dollarda eng ko'p saqlash mumkin bo'lgan miqdori ($)
    // Butun songa yaxlitlanmaydi (Math.floor) — aks holda tiyin qismi so'mda "qoldiq" bo'lib
    // qolib ketardi. 2 xonagacha (sentgacha) yaxlitlanadi, shunda MAX bosilganda butun qarz
    // to'liq dollarda yopiladi, so'm qarz 0 bo'lib qoladi.
    maxQarzDollar() {
      return this.rate > 0 ? Math.round((this.qarzgaQoladi / this.rate) * 100) / 100 : 0;
    },

    qarzDollar() {
      return Number(this.form.qarz_dollar) || 0;
    },

    // Dollarda saqlangan qarzdan keyin qolgan so'm qarzi
    somQarz() {
      const left = this.qarzgaQoladi - this.qarzDollar * this.rate;
      return left > 0 ? left : 0;
    },

    dollarQuickButtons() {
      const fixed = QARZ_QUICK_VALUES.map(v => ({ label: `${v} $`, value: v, max: false }));
      fixed.push({ label: `MAX (${this.maxQarzDollar} $)`, value: this.maxQarzDollar, max: true });
      return fixed;
    },

    debtPayTotal() {
      return (this.debtPayTable || []).reduce((acc, r) => {
        const s = parseFloat(r.summa) || 0;
        if (s <= 0) return acc;
        if (parseInt(r.pay_type_id) === 3) return acc + s * this.rate;
        return acc + s;
      }, 0);
    },
  },
  methods: {
    formatSumma(s) { return Number(s || 0).toLocaleString(); },
    formatPrice(som, dollar = 0) {
      if (this.isDollarMode) {
        const value = Number(dollar) > 0 ? Number(dollar) : Number(som || 0) / this.rate;
        return `$ ${value.toFixed(2)}`;
      }
      return `${this.formatSumma(som)} so'm`;
    },
    setCurrencyMode(mode) {
      this.emitPayments({ currency_mode: mode });
    },
    serviceItemPrice(item) {
      if (this.saleType === 'optom') {
        return Number(item.labor_price_optom || 0) + Number(item.redo_price_optom || 0);
      }
      return Number(item.labor_price_chakana || 0) + Number(item.redo_price_chakana || 0);
    },
    // Shu xizmatga tegishli zapchastlar (materiallar) summasi — faqat ko'rsatish uchun,
    // chekda chiqmaydi (chek alohida shablon orqali chop etiladi)
    serviceMaterialsSumma(item) {
      return this.cart
        .filter(c => c.type === 'product' && c.from_service === item.id)
        .reduce((acc, c) => acc + Number(c.price || 0) * Number(c.qty || 0), 0);
    },
    updateForm(key, e) {
      let val = e && e.target ? e.target.value : e;
      if (key !== 'nasiya_date' && key !== 'comment' && key !== 'car_number') {
        val = Number(val) || 0;
      }
      this.$emit('update:form', { ...this.form, [key]: val });
    },

    // Pay tur qiymatini olish (system: form[field], custom: form.pay_table_amounts[id])
    getPayValue(def) {
      if (def.custom) {
        const map = this.form.pay_table_amounts || {};
        return parseFloat(map[def.id]) || 0;
      }
      return parseFloat(this.form[def.field]) || 0;
    },

    // To'lov maydonlarini yangilab, pay_table ni qayta yig'ib, qarz_dollar ni cheklab emit qiladi
    emitPayments(overrides = {}) {
      const f = { ...this.form, ...overrides };
      // custom turlar uchun map ni klonlash (immutable)
      f.pay_table_amounts = { ...(f.pay_table_amounts || {}) };
      if (overrides.pay_table_amounts) f.pay_table_amounts = { ...overrides.pay_table_amounts };

      const rate = parseFloat(f.dollar_rate || this.dollarRate) || 1;

      let paid = 0;
      const pay_table = [];
      for (const d of this.activeDefs) {
        let v = 0;
        if (d.custom) {
          v = parseFloat(f.pay_table_amounts[d.id]) || 0;
          if (v < 0) v = 0;
          f.pay_table_amounts[d.id] = v;
        } else {
          v = parseFloat(f[d.field]) || 0;
          if (v < 0) v = 0;
          f[d.field] = v;
        }
        if (v > 0) {
          pay_table.push({ pay_type_id: d.id, summa: v });
          paid += d.dollar ? v * rate : v;
        }
      }
      f.pay_table = pay_table;

      // Dollar rejimida qolgan qarz avtomatik ravishda dollarda saqlanadi.
      const remaining = Math.max(0, this.totalSum - paid);
      const maxDollar = rate > 0 ? remaining / rate : 0;
      let qd = parseFloat(f.qarz_dollar) || 0;
      if (f.currency_mode === 'dollar') {
        qd = maxDollar;
      } else {
        if (qd < 0) qd = 0;
        if (qd > maxDollar) qd = maxDollar;
      }
      f.qarz_dollar = qd;

      this.$emit('update:form', f);
    },

    onCardInput(def, e) {
      // summa-input Number qiymat emit qiladi; oddiy input esa event beradi
      const raw = (e && e.target) ? e.target.value : e;
      const val = parseFloat(raw) || 0;
      const safe = val < 0 ? 0 : val;
      if (def.custom) {
        const map = { ...(this.form.pay_table_amounts || {}), [def.id]: safe };
        this.emitPayments({ pay_table_amounts: map });
      } else {
        this.emitPayments({
          [def.field]: safe,
          ...(def.dollar && safe > 0 ? { currency_mode: 'dollar' } : {}),
        });
      }
    },

    // "Qoldiq" — shu to'lov turiga qolgan summani to'ldiradi
    fillRemainder(def) {
      let otherPaid = 0;
      for (const d of this.activeDefs) {
        if (d.id === def.id) continue;
        const v = this.getPayValue(d);
        otherPaid += d.dollar ? v * this.rate : v;
      }
      let rem = this.totalSum - otherPaid;
      if (rem < 0) rem = 0;
      const val = def.dollar
        ? (this.rate > 0 ? Math.round((rem / this.rate) * 100) / 100 : 0)
        : rem;
      if (def.custom) {
        const map = { ...(this.form.pay_table_amounts || {}), [def.id]: val };
        this.emitPayments({ pay_table_amounts: map });
      } else {
        this.emitPayments({
          [def.field]: val,
          ...(def.dollar && val > 0 ? { currency_mode: 'dollar' } : {}),
        });
      }
    },

    payAllCash() {
      this.emitPayments({
        cash_summa: this.totalSum > 0 ? this.totalSum : 0,
        plastic_summa: 0, shot_summa: 0, dollar_summa: 0,
        pay_table_amounts: {}, // custom turlarni tozalash
        qarz_dollar: 0,
      });
    },

    payAllDebt() {
      this.emitPayments({
        cash_summa: 0, plastic_summa: 0, shot_summa: 0, dollar_summa: 0,
        pay_table_amounts: {},
        qarz_dollar: 0,
      });
    },

    setQarzDollar(value) {
      let v = parseFloat(value) || 0;
      if (v < 0) v = 0;
      if (v > this.maxQarzDollar) v = this.maxQarzDollar;
      this.$emit('update:form', { ...this.form, qarz_dollar: v });
    },
    onQarzDollarInput(e) {
      this.setQarzDollar(e.target.value);
    },

    payDebt() {
      if (this.debtLoading || this.debtPayTotal <= 0) return;
      this.debtLoading = true;
      this.$emit('pay-debt', {
        pay_table: this.debtPayTable.map(row => ({ ...row })),
        done: success => {
          this.debtLoading = false;
          if (success) this.debtPayTable = [];
        },
      });
    },
  },
};
</script>

<style scoped>
/* Sidebar layout — to'g'ri balandlik va scroll */
.cart-sidebar {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 100px);
  max-height: calc(100vh - 100px);
  position: sticky;
  top: 10px;
}
.cart-header {
  flex-shrink: 0;
}
.currency-switch {
  display: inline-flex;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.45);
  border-radius: 6px;
}
.currency-switch button {
  min-width: 38px;
  padding: 3px 7px;
  border: 0;
  background: transparent;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
}
.currency-switch button.active {
  background: #fff;
  color: #111827;
}
.return-row {
  color: #047857;
}
.cart-items {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}
.cart-summary {
  flex-shrink: 0;
  max-height: 60vh;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
/* Detallar + to'lov turlari shu yerda scroll bo'ladi */
.summary-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  margin: -4px -4px 0;
  padding: 4px;
}
/* Amal tugmalari (Sotishni yakunlash / Kechiktirish) scrolldan tashqarida — doim ko'rinadi */
.cart-summary > .btn-checkout,
.cart-summary > .btn-park {
  flex-shrink: 0;
}

/* Cart items */
.cart-row {
  background: #f8fafc;
  border-radius: 10px;
  padding: 10px;
}
.service-row {
  background: #f5f0ff;
  border-left: 3px solid #a142f4;
}
.service-product-row {
  background: #f0f4ff;
  border-left: 3px solid #60a5fa;
  padding: 6px 10px;
  margin-left: 12px;
}
.quantity-control {
  display: flex;
  align-items: center;
  background: white;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}
.qty-btn {
  border: none;
  background: none;
  padding: 2px 10px;
  font-weight: bold;
  cursor: pointer;
}
.qty-val {
  padding: 0 8px;
  font-weight: 600;
}
.btn-close-sm {
  background: none;
  border: none;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  color: #94a3b8;
}
.btn-close-sm:hover { color: #ef4444; }

/* Summary inputs */
.summary-input-field {
  width: 120px;
  text-align: right;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 4px 8px;
  font-weight: 700;
  font-size: 0.9rem;
}
.summary-input-field:focus {
  border-color: #3b82f6;
  outline: none;
}

/* ================= To'lov turlari ================= */
.pay-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.pay-head-title {
  font-weight: 800;
  font-size: 0.78rem;
  letter-spacing: 0.5px;
  color: #475569;
}
.btn-all-cash {
  border: none;
  background: #fdf2f8;
  color: #be185d;
  font-weight: 700;
  font-size: 0.72rem;
  padding: 5px 12px;
  border-radius: 20px;
  cursor: pointer;
  transition: 0.15s;
}
.btn-all-cash:hover { background: #fce7f3; }

.pay-card {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fff;
  border: 1.5px solid #eef2f7;
  border-radius: 14px;
  padding: 8px 10px;
  margin-bottom: 8px;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.pay-card-filled {
  border-color: #a142f4;
  box-shadow: 0 0 0 3px rgba(161, 66, 244, 0.08);
}
.pay-card-icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  flex-shrink: 0;
}
.pay-card-meta { flex-shrink: 0; min-width: 78px; }
.pay-card-name {
  font-weight: 700;
  font-size: 0.82rem;
  color: #1e293b;
  line-height: 1.1;
}
.pay-card-sub {
  font-size: 0.6rem;
  color: #94a3b8;
  font-weight: 600;
}
.pay-card-input {
  flex: 1;
  min-width: 0;
}
.pay-card-input input {
  width: 100%;
  border: 1px solid #e2e8f0;
  border-radius: 9px;
  padding: 7px 10px;
  font-weight: 700;
  font-size: 0.9rem;
  text-align: right;
  outline: none;
}
.pay-card-input input:focus {
  border-color: #a142f4;
}
.pay-card-hint {
  display: block;
  font-size: 0.62rem;
  color: #16a34a;
  font-weight: 600;
  text-align: right;
  margin-top: 2px;
}
.btn-qoldiq {
  flex-shrink: 0;
  border: none;
  background: #f1f5f9;
  color: #475569;
  font-weight: 700;
  font-size: 0.72rem;
  padding: 7px 12px;
  border-radius: 9px;
  cursor: pointer;
  transition: 0.15s;
}
.btn-qoldiq:hover { background: #e2e8f0; }

.pay-totals {
  border-top: 1px dashed #e2e8f0;
  padding-top: 10px;
}

/* ================= QARZ TURI ================= */
/* Mijoz tanlanmagan ogohlantirishi */
.qarz-warning {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border: 1.5px solid #fca5a5;
  border-radius: 10px;
  padding: 8px 12px;
  font-size: 12px;
  color: #b91c1c;
  margin: 8px 0 12px;
  display: flex;
  align-items: center;
  gap: 4px;
  animation: warn-pulse 1.5s ease-in-out infinite;
}
@keyframes warn-pulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(220, 38, 38, 0.15); }
  50% { box-shadow: 0 0 0 4px rgba(220, 38, 38, 0); }
}

.qarz-turi {
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 14px;
  padding: 12px;
}
.qarz-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.qarz-title {
  font-weight: 800;
  font-size: 0.78rem;
  color: #b45309;
}
.qarz-kurs {
  font-size: 0.72rem;
  font-weight: 700;
  color: #92400e;
}
.qarz-quick {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 10px;
}
.qarz-q-btn {
  border: 1px solid #fcd34d;
  background: #fff;
  color: #92400e;
  font-weight: 700;
  font-size: 0.72rem;
  padding: 5px 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.15s;
}
.qarz-q-btn:hover { background: #fef3c7; }
.qarz-q-btn.active {
  background: #f59e0b;
  border-color: #f59e0b;
  color: #fff;
}
.qarz-q-btn.qarz-q-max {
  background: #16a34a;
  border-color: #16a34a;
  color: #fff;
  margin-left: auto;
}
.qarz-q-btn.qarz-q-max.active {
  background: #15803d;
  border-color: #15803d;
}
.qarz-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 8px;
}
.qarz-row label {
  font-size: 0.78rem;
  font-weight: 700;
  color: #78350f;
  margin: 0;
}
.qarz-dollar-input {
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #fcd34d;
  border-radius: 9px;
  overflow: hidden;
}
.qarz-dollar-input input {
  width: 90px;
  border: none;
  padding: 7px 10px;
  font-weight: 700;
  text-align: right;
  outline: none;
}
.qarz-cur {
  padding: 0 10px;
  font-weight: 800;
  color: #92400e;
}
.qarz-som-row { margin-bottom: 0; }
.qarz-date {
  border: 1px solid #fcd34d;
  border-radius: 9px;
  padding: 6px 8px;
  font-size: 0.8rem;
  background: #fff;
  flex: 1;
}

/* Hammasi qarzga */
.btn-all-debt {
  width: 100%;
  border: 1.5px dashed #fca5a5;
  background: #fef2f2;
  color: #b91c1c;
  font-weight: 700;
  font-size: 0.82rem;
  padding: 10px;
  border-radius: 12px;
  cursor: pointer;
  transition: 0.15s;
}
.btn-all-debt:hover { background: #fee2e2; }

/* Status badges */
.status-badge {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  padding: 6px 10px;
  font-size: 0.82rem;
  font-weight: 600;
}
.paid-badge {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  color: #15803d;
}

/* Debt section */
.debt-section {
  background: #fff5f5;
}

/* Checkout btn */
.btn-checkout {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  border: none;
  font-weight: 800;
  letter-spacing: 1px;
  position: sticky;
  bottom: 0;
  z-index: 2;
}
.btn-checkout:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  background: linear-gradient(135deg, #94a3b8 0%, #64748b 100%);
}

/* Kechiktirish (hold) tugmasi */
.btn-park {
  background: #fffbeb;
  color: #b45309;
  border: 1.5px solid #fcd34d;
  font-weight: 800;
  letter-spacing: 0.5px;
  transition: 0.15s;
}
.btn-park:hover:not(:disabled) {
  background: #fef3c7;
  border-color: #f59e0b;
}
.btn-park:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Ixchamroq ko'rinish kichik ekranlarda */
@media (max-height: 800px) {
  .cart-summary { padding: 10px !important; }
  .payment-section { margin-top: 8px !important; }
  .summary-details > div { margin-bottom: 2px !important; }
}

/* Tor telefon ekranlarida to'lov kartochkasi (ikonka+nomi+summa+"Qoldiq")
   bitta qatorga sig'may qolmasligi uchun ikki qatorga bo'linadi */
@media (max-width: 420px) {
  .pay-card {
    flex-wrap: wrap;
  }
  .pay-card-input {
    order: 3;
    flex-basis: calc(100% - 48px);
  }
  .btn-qoldiq {
    order: 4;
    margin-left: auto;
  }
}

/* Badge colors */
.bg-purple { background-color: #a142f4 !important; }
.text-purple { color: #a142f4 !important; }
</style>
